// @flow

import {
    // ConnectionHandler,
    Environment
} from 'relay-runtime'
import {
    commitMutation,
    graphql,
} from 'react-relay'

const addMutation = graphql `
    mutation TopicAddMutation(
        $input: TopicAddInput!
    ) {
        TopicAdd(input: $input) {
            topicEdge {
                node {
                    ...Topic_topic
                }
            }
        }
    }
`

// function sharedUpdater(store, vid, newEdge) {
//     const userProxy = store.get(vid);
//     const conn = ConnectionHandler.getConnection(
//         userProxy,
//         'TopicsEditor_topics',
//     );
//     ConnectionHandler.insertEdgeAfter(conn, newEdge);
// }

let tempID = 0;

export function commit(environment: Environment, params: any, vid: string, callback: (error: ? Error, id : ? string) => void) {
    commitMutation(
        environment, {
            mutation: addMutation,
            variables: {
                input: {
                    ...params,
                    clientMutationId: tempID++
                }
            },
            onCompleted: (response) => {
                if (response.error !== null && response.error !== undefined) {
                    callback(response.error, null)
                    return
                }
                console.log('response')
                console.log(response)
                callback(null, response.TopicAdd.topicEdge.node.__id)
            },
            onError: (error) => {
                callback(error, null)
            },
            // updater: (store) => {
            //     const payload = store.getRootField('TopicAdd');
            //     const newEdge = payload.getLinkedRecord('topicEdge');
            //     sharedUpdater(store, vid, newEdge);
            // },
            // optimisticUpdater: (store) => {
            //     const id = 'client:newTopic:' + tempID++;
            //     const node = store.create(id, 'Topic');
            //     node.setValue(params.name, 'name');
            //     node.setValue(false, 'hidden');
            //     node.setValue(id, 'id');
            //     const newEdge = store.create(
            //         'client:newEdge:' + tempID++,
            //         'topicEdge',
            //     );
            //     newEdge.setLinkedRecord(node, 'node');
            //     sharedUpdater(store, vid, newEdge);
            // },
        })
}



// WEBPACK FOOTER //
// src/mutations/TopicAddMutation.js